import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right";
import { useLineItemsListSections } from "@/pages/(app)/returns/refund/hooks/use-line-items-list-sections";
import useLineItemsQuantitiesSummary from "@/pages/(app)/returns/refund/hooks/use-line-items-quantities-summary";
import {
  useRejectedByLogistician,
  useSetRejectedByLogistician,
} from "@/pages/(app)/returns/refund/hooks/use-line-items-state-context";
import { useRefundLineItem } from "@/pages/(app)/returns/refund/hooks/use-refund-line-items-context";
import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@babackapp/ui/components/accordion";
import { Badge } from "@babackapp/ui/components/badge";
import NumberFlow from "@number-flow/react";
import { ArticleItem } from "../article-item/article-item";
import { getMaxQuantityRejected } from "./use-refund.view-model";

export default function ArticlesRejectedByLogistician() {
  const t = useTranslation();
  const { itemsRejectedByLogistician } = useLineItemsListSections();
  const hasPermissionToView = useViewerHasAtLeastAdminRights();
  const summary = useLineItemsQuantitiesSummary({
    state: "rejected-by-logistician",
  });

  if (!itemsRejectedByLogistician.length || !hasPermissionToView) {
    return null;
  }

  return (
    <AccordionItem value="rejectedByLogistician">
      <AccordionTrigger>
        <span>
          {t("returnDetail.confirmModal.rejectedByLogistician")}
          <Badge variant="secondary" className="ml-2">
            <NumberFlow value={summary.selected} suffix={` / ${summary.max}`} />
          </Badge>
        </span>
      </AccordionTrigger>
      <AccordionContent>
        <div className="border-border border rounded-md flex-col gap-4 divide-y overflow-hidden">
          {itemsRejectedByLogistician.map((lineItem) => (
            <RejectedByLogisticianArticle
              key={lineItem.line_item_id}
              lineItem={lineItem}
            />
          ))}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}

function RejectedByLogisticianArticle({
  lineItem,
}: {
  lineItem: ReturnRequestLineItemDto;
}) {
  const { item, updateResolution, updateVariant } = useRefundLineItem(lineItem);
  const quantityValue = useRejectedByLogistician(lineItem.line_item_id);
  const updateQuantity = useSetRejectedByLogistician(lineItem.line_item_id);
  return (
    <ArticleItem
      lineItem={item}
      quantity={quantityValue.selectedQuantity}
      maxQuantity={getMaxQuantityRejected(lineItem)}
      onChangeQuantity={updateQuantity}
      onChangeVariant={updateVariant}
      onChangeResolution={updateResolution}
      hideStatus
    />
  );
}
